import common from './vi/common';
import message from './vi/message';
import validation from './vi/validation';
import auth from './vi/auth';
import notification from './vi/notification';
import user from './vi/user';

const locales = {
  common,
  message,
  validation,
  auth,
  notification,
  user
};

export default locales;
